module.exports = __webpack_public_path__ + "static/media/lupa_mobile.c5c74869.svg";